import { Dialog, DialogActions, Typography } from "@mui/material";

const LotDeleteModal = ({
  showLotCartDeleteModal,
  setShowLotCartDeleteModal,
  lotDrugCart,
  setLotDrugCart,
  lotDrugDeleteId,
  setLotDrugDeleteId,
}) => {
  return (
    <Dialog
      open={showLotCartDeleteModal}
      onClose={() => setShowLotCartDeleteModal(false)}
    >
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Delete Cart Items
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Are you sure you want to delete the cart items?
        </Typography>
      </div>
      <DialogActions>
        <button
          className="create-btn"
          style={{ width: "120px" }}
          onClick={() => {
            let tempData = lotDrugCart.filter(
              (item) => item.uniqueId !== lotDrugDeleteId
            );
            setLotDrugCart(tempData);
            setLotDrugDeleteId(null);
            setShowLotCartDeleteModal(false);
          }}
        >
          Yes
        </button>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => setShowLotCartDeleteModal(false)}
        >
          No
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default LotDeleteModal;
